import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { getRoleDashboardPath } from "./AuthGuard";

const AccessDeniedPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { caraUser } = useAuth();

  // Get the attempted route from location state
  const attemptedRoute = location.state?.from || 'unknown route';
  const customMessage = location.state?.message;

  // Bug_Id_356: send users to their own role's dashboard, not the CARA one
  // (a TPRM user is denied /assessment_dashboard, and stepping "back" past a
  // fresh login lands on the login page / back-logout prompt).
  const dashboardPath = getRoleDashboardPath(caraUser?.role || localStorage.getItem('role'));

  const handleGoBack = () => {
    // Only step back to a page the router itself pushed; otherwise go home.
    if (window.history.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate(dashboardPath, { replace: true });
    }
  };

  const handleGoToDashboard = () => {
    navigate(dashboardPath);
  };

  const handleContactSupport = () => {
    // You can add logic to open support chat or redirect to support page
    navigate('/ask_the_expert');
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="card shadow-lg border-0">
              <div className="card-body text-center p-5">
                {/* Lock Icon */}
                <div className="mb-4">
                  <i className="fas fa-lock fa-4x text-danger"></i>
                </div>

                {/* Title */}
                <h2 className="mb-3 text-dark fw-bold">Access Denied</h2>

                {/* Description */}
                <p className="text-muted mb-4 fs-5">
                  {customMessage || "You don't have permission to access this page."}
                </p>

                {/* Attempted Route Info */}
                <div className="bg-light p-3 rounded mb-4">
                  <small className="text-muted">
                    <strong>Attempted Route:</strong> <code>{attemptedRoute}</code>
                  </small>
                </div>

                {/* User Info */}
                <div className="bg-light p-3 rounded mb-4">
                  <small className="text-muted">
                    <strong>User:</strong> {caraUser?.first_name} {caraUser?.last_name} <br />
                    <strong>Role:</strong> {caraUser?.role} <br />
                    {/* <strong>Package:</strong> {caraUser?.package} */}
                  </small>
                </div>

                {/* Action Buttons */}
                <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                  <button
                    className="btn btn-primary btn-lg me-md-2"
                    onClick={handleGoBack}
                  >
                    <i className="fas fa-arrow-left me-2"></i>
                    Go Back
                  </button>

                  <button
                    className="btn btn-outline-primary btn-lg me-md-2"
                    onClick={handleGoToDashboard}
                  >
                    <i className="fas fa-home me-2"></i>
                    Dashboard
                  </button>

                  <button
                    className="btn btn-outline-secondary btn-lg"
                    onClick={handleContactSupport}
                  >
                    <i className="fas fa-headset me-2"></i>
                    Support
                  </button>
                </div>

                {/* Additional Help */}
                <div className="mt-4 pt-4 border-top">
                  <p className="text-muted small mb-2">
                    Need additional access or features?
                  </p>
                  <small className="text-muted">
                    Contact your administrator or upgrade your plan to access this feature.
                  </small>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="text-center mt-4">
              <small className="text-muted">
                © 2024 CARA Platform. All rights reserved.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
